import { formatDate, formatAmount } from '@/util/helpers'
import subscriptionStatuses from '@/util/subscriptionStatuses'
import transactionStatuses from '@/util/transactionStatuses'
import paymentMethods from '@/util/paymentMethods'

export default function () {
  return {
    formatDate,
    formatAmount,
    subscriptionStatuses,
    transactionStatuses,
    paymentMethods,
    subscription: {},
  }
}
